import { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { List, Info, X } from "@phosphor-icons/react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "../ui/sheet";
import { SidebarContent } from "./Sidebar";
import { useAuth } from "../../context/AuthContext";

function TempPasswordReminder() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  if (!user?.password_is_temporary || dismissed) return null;
  return (
    <div
      data-testid="temp-password-banner"
      className="sticky top-0 z-50 flex items-center justify-center gap-2 px-4 py-2 text-center text-sm"
      style={{ backgroundColor: "#FEF3C7", color: "#92400E" }}
    >
      <Info size={18} weight="fill" />
      <span>
        You're using a temporary password.{" "}
        <Link to="/account" className="underline font-semibold">
          Set your own password
        </Link>{" "}
        when you're ready.
      </span>
      <button
        onClick={() => setDismissed(true)}
        data-testid="dismiss-temp-banner"
        className="ml-2 opacity-70 hover:opacity-100"
      >
        <X size={16} />
      </button>
    </div>
  );
}

export function AppLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="grain-bg min-h-screen">
      <TempPasswordReminder />
      <div className="flex">
        <aside className="hidden lg:block fixed inset-y-0 left-0 w-72 border-r border-border">
          <SidebarContent />
        </aside>
        <div className="flex-1 lg:pl-72 min-h-screen">
          <div className="lg:hidden sticky top-0 z-40 flex items-center justify-between border-b border-border bg-sidebar/90 backdrop-blur-xl px-4 py-3">
            <div>
              <span className="font-heading text-xl tracking-[0.12em] text-primary">
                GLEDSWOOD
              </span>
              <span className="ml-2 text-[9px] tracking-[0.14em] uppercase text-muted-foreground">
                Plan
              </span>
            </div>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <button
                  data-testid="mobile-menu-trigger"
                  className="rounded-lg p-2 text-primary hover:bg-muted transition-colors duration-200"
                  aria-label="Open navigation"
                >
                  <List size={24} />
                </button>
              </SheetTrigger>
              <SheetContent side="left" className="p-0 w-72">
                <SheetTitle className="sr-only">Navigation menu</SheetTitle>
                <SidebarContent onNavigate={() => setOpen(false)} />
              </SheetContent>
            </Sheet>
          </div>
          <main className="px-5 py-8 sm:px-8 lg:px-12 lg:py-12 max-w-7xl mx-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
